export default "__VITE_ASSET__acc84629__"